// import React, { useState, useEffect, useRef } from 'react';
// import ExportLabel from '../../../components/common/ExportLabel/Export';
// import PageHeader from '../../../components/common/PageHeader/PageHeader';
// import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
// import './ReleaseNotes.css';
// import AddButtonWithPlus from '../../../components/common/AddButton/AddButton';
// import InputBoxSmall from '../../../components/common/InputBox/InputBoxSmall';
// import IconUploadButton from '../../../components/common/InputBox/UploadIconBox';

// const EditReleaseNotes = () => {
//     const [selectedItems, setSelectedItems] = useState([]);
//     const [showImprovementInput, setShowImprovementInput] = useState(false);
//     const [newImprovementText, setNewImprovementText] = useState('');
//     const improvementInputRef = useRef(null);
//     const [showBugInput, setShowBugInput] = useState(false);
//     const [newBugText, setNewBugText] = useState('');
//     const [showFeatureInput, setShowFeatureInput] = useState(false);
//     const [newFeatureName, setNewFeatureName] = useState('');
//     const [newFeatureDescription, setNewFeatureDescription] = useState(''); 
//     const [newFeatureIcon, setNewFeatureIcon] = useState(null);
//     // Feature edit
//     const [editFeatureId, setEditFeatureId] = useState(null);
//     const [editFeatureName, setEditFeatureName] = useState('');
//     const [editFeatureDescription, setEditFeatureDescription] = useState('');
//     const [editFeatureIcon, setEditFeatureIcon] = useState(null);

//     // Improvement edit
//     const [editImprovementId, setEditImprovementId] = useState(null);
//     const [editImprovementText, setEditImprovementText] = useState('');

//     // Bug edit
//     const [editBugId, setEditBugId] = useState(null);
//     const [editBugText, setEditBugText] = useState('');

//     const [features, setFeatures] = useState([
//         { id: 1, name: "AI Route Optimization", description: "Automatically generate smarter delivery routes." },
//         { id: 2, name: "Advanced GPS Tracking", description: "Track sales reps and vehicles in real time." }
//     ]);

//     const [improvements, setImprovements] = useState([
//         { id: 1, text: "Faster Invoice Loading" },
//         { id: 2, text: "Improved Bank Reconciliation" }
//     ]);

//     const [bugs, setBugs] = useState([
//         { id: 1, text: "Faster Invoice Loading" },
//         { id: 2, text: "Resolved Duplicate Invoice Bug" }
//     ]);

//     return (
//         <div className='whole-container'>
//           <div className='top-heading'>
//             <PageHeader pageName=" Engagement / Release Notes /" nestedpageName="Edit" linkTo="" />
//             <div className='export-container'>
//               <ArchiveSelectedItem selectedItems={selectedItems} />
//               <ExportLabel />
//             </div>
//           </div>
//           <div className='pagename-container'>
//             <div className='page-name'>
//               <h1 className='common-text fts-22 ftw-6 blue'>Release Note Edit</h1>
//             </div>
//           </div>
//           <div className='table-container'>
//             <div className='add-release-note-container'>
//                 <div className='release-basic-container'>
//                     <div className='release-basic-header'>
//                         <span className='release-header-title'>Basic Information</span>
//                     </div>
//                     <div className='release-basic-content'>
//                         <div className='release-version-container'>
//                             <InputBoxSmall label="Version" />
//                         </div>
//                         <div className='release-basic-description-container'>
//                             <InputBoxSmall label="Release title" />
//                             <InputBoxSmall 
//                             label="Release date"
//                             type = 'small-date' />
//                             <InputBoxSmall label="Status" />
//                         </div>
//                         <div className='release-basic-bt-text'>
//                             <span>This title is for internal use only and will not be shown to users.</span>
//                         </div>
//                     </div>
//                 </div>
//                 <div className='release-feature-container'>
//                     <div className='release-feature-header'>
//                         <span className='release-header-title'>Feature Information</span>
//                     </div>
//                     <div className='release-feature-content-container'>
//                         <div className='release-feature-titles'>
//                             <span>Icon</span>
//                             <span>Feature Name</span>
//                             <span>Description (40–50 characters)</span>
//                         </div>
//                         <div className='release-feature-content'>
//                             {features.map((item) => (
//                                 <div className='release-feature-row' key={item.id}>
//                                     {editFeatureId === item.id ? (
//                                         // ── EDIT MODE ──
//                                         <div
//                                             className='release-input-row'
//                                             onKeyDown={(e) => {
//                                                 if (e.key === 'Enter' && editFeatureName.trim()) {
//                                                     setFeatures(prev =>
//                                                         prev.map(f => f.id === item.id
//                                                             ? { ...f, name: editFeatureName.trim(), description: editFeatureDescription.trim(), icon: editFeatureIcon }
//                                                             : f
//                                                         )
//                                                     );
//                                                     setEditFeatureId(null);
//                                                 }
//                                                 if (e.key === 'Escape') setEditFeatureId(null);
//                                             }}
//                                         >
//                                             <IconUploadButton
//                                                 icon={editFeatureIcon}
//                                                 onIconChange={(icon) => setEditFeatureIcon(icon)}
//                                             />
//                                             <InputBoxSmall
//                                                 label="Feature Name"
//                                                 defaultValue={editFeatureName}
//                                                 onChange={(e) => setEditFeatureName(e.target.value)}
//                                             />
//                                             <InputBoxSmall
//                                                 label="Description (40–50 characters)"
//                                                 defaultValue={editFeatureDescription}
//                                                 onChange={(e) => setEditFeatureDescription(e.target.value)}
//                                             />
//                                             <div
//                                                 className="release-close-icon"
//                                                 onClick={() => setEditFeatureId(null)}
//                                             >
//                                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                                     <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                 </svg>
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         // ── VIEW MODE ──
//                                         <>
//                                             <div className='release-feature-content-left-row'>
//                                                 <IconUploadButton
//                                                     icon={item.icon}
//                                                     onIconChange={(newIcon) =>
//                                                         setFeatures(prev =>
//                                                             prev.map(f => f.id === item.id ? { ...f, icon: newIcon } : f)
//                                                         )
//                                                     }
//                                                 />
//                                                 <span>{item.name}</span>
//                                                 <span>{item.description}</span>
//                                             </div>
//                                             <div className='release-feature-content-right-row'>
//                                                 {/* Edit icon */}
//                                                 <svg
//                                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
//                                                     style={{ cursor: 'pointer' }}
//                                                     onClick={() => {
//                                                         setEditFeatureId(item.id);
//                                                         setEditFeatureName(item.name);
//                                                         setEditFeatureDescription(item.description);
//                                                         setEditFeatureIcon(item.icon ?? null);
//                                                     }}
//                                                 >
//                                                     <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     <path d="M12.25 1.74917C12.5152 1.48396 12.8749 1.33496 13.25 1.33496C13.6251 1.33496 13.9848 1.48396 14.25 1.74917C14.5152 2.01439 14.6642 2.3741 14.6642 2.74917C14.6642 3.12425 14.5152 3.48396 14.25 3.74917L8.24133 9.75851C8.08303 9.91667 7.88747 10.0325 7.67267 10.0952L5.75733 10.6552C5.69997 10.6719 5.63916 10.6729 5.58127 10.6581C5.52339 10.6432 5.47055 10.6131 5.4283 10.5709C5.38604 10.5286 5.35592 10.4758 5.34109 10.4179C5.32626 10.36 5.32727 10.2992 5.344 10.2418L5.904 8.32651C5.96702 8.11187 6.08302 7.91655 6.24133 7.75851L12.25 1.74917Z" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
//                                                 </svg>
//                                                 {/* Delete icon */}
//                                                 <svg
//                                                     xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
//                                                     style={{ cursor: 'pointer' }}
//                                                     onClick={() => setFeatures(prev => prev.filter(f => f.id !== item.id))}
//                                                 >
//                                                     <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                 </svg>
//                                             </div>
//                                         </>
//                                     )}
//                                 </div>
//                             ))}
//                             {showFeatureInput && (
//                                 <div className='release-input-row'
//                                     onKeyDown={(e) => {
//                                         if (e.key === 'Enter' && newFeatureName.trim()) {
//                                             setFeatures(prev => [
//                                                 ...prev,
//                                                 {
//                                                     id: Date.now(),
//                                                     name: newFeatureName.trim(),
//                                                     description: newFeatureDescription.trim(),
//                                                     icon: newFeatureIcon
//                                                 }
//                                             ]);
//                                             setNewFeatureName('');
//                                             setNewFeatureDescription('');
//                                             setNewFeatureIcon(null);
//                                             setShowFeatureInput(false);
//                                         }
//                                         if (e.key === 'Escape') {
//                                             setNewFeatureName('');
//                                             setNewFeatureDescription('');
//                                             setNewFeatureIcon(null);
//                                             setShowFeatureInput(false);
//                                         }
//                                     }}
//                                 >
//                                     <IconUploadButton
//                                         icon={newFeatureIcon}
//                                         onIconChange={(icon) => setNewFeatureIcon(icon)}
//                                     />

//                                     <InputBoxSmall
//                                         label="Feature Name"
//                                         value={newFeatureName}
//                                         onChange={(e) => setNewFeatureName(e.target.value)}
//                                     />

//                                     <InputBoxSmall
//                                         label="Description (40–50 characters)"
//                                         value={newFeatureDescription}
//                                         onChange={(e) => setNewFeatureDescription(e.target.value)}
//                                     />

//                                     {/* ❌ CLOSE BUTTON */}
//                                     <div
//                                     className="release-close-icon"
//                                         onClick={() => {
//                                             setNewFeatureName('');
//                                             setNewFeatureDescription('');
//                                             setNewFeatureIcon(null);
//                                             setShowFeatureInput(false);
//                                         }}
//                                     >
//                                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                             <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                             <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                         </svg>
//                                     </div>
//                                 </div>
//                             )}

//                             <div className='release-feature-add'>
//                                 <AddButtonWithPlus onClick={() => setShowFeatureInput(true)} />
//                             </div>
//                         </div>
//                     </div>
//                     <hr/>
//                     <div className='release-btm-container'>
//                         <div className='release-btm-left'>
//                             <div className='release-btm-left-title'>
//                                 <span>Improvements</span>
//                             </div>
//                             <div className='release-btm-left-content'>
//                                 {improvements.map((item) => (
//                                     <div className='release-btm-left-content-row' key={item.id}>
//                                         {editImprovementId === item.id ? (
//                                             // ── EDIT MODE ──
//                                             <div
//                                                 className='release-input-row'
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter' && editImprovementText.trim()) {
//                                                         setImprovements(prev =>
//                                                             prev.map(i => i.id === item.id
//                                                                 ? { ...i, text: editImprovementText.trim() }
//                                                                 : i
//                                                             )
//                                                         );
//                                                         setEditImprovementId(null);
//                                                     }
//                                                     if (e.key === 'Escape') setEditImprovementId(null);
//                                                 }}
//                                             >
//                                                 <InputBoxSmall
//                                                     label="Improvement"
//                                                     defaultValue={editImprovementText}
//                                                     onChange={(e) => setEditImprovementText(e.target.value)}
//                                                 />
//                                                 <div
//                                                     className="release-close-icon"
//                                                     onClick={() => setEditImprovementId(null)}
//                                                 >
//                                                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                                         <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                         <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     </svg>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             // ── VIEW MODE ──
//                                             <>
//                                                 <span className='imp-icon-left'></span>
//                                                 <span className='release-btm-text-left'>{item.text}</span>
//                                                 <div className='release-btm-text-right'>
//                                                     {/* Edit icon */}
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
//                                                         style={{ cursor: 'pointer' }}
//                                                         onClick={() => {
//                                                             setEditImprovementId(item.id);
//                                                             setEditImprovementText(item.text);
//                                                         }}
//                                                     >
//                                                         <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
//                                                         <path d="M12.25 1.74917C12.5152 1.48396 12.8749 1.33496 13.25 1.33496C13.6251 1.33496 13.9848 1.48396 14.25 1.74917C14.5152 2.01439 14.6642 2.3741 14.6642 2.74917C14.6642 3.12425 14.5152 3.48396 14.25 3.74917L8.24133 9.75851C8.08303 9.91667 7.88747 10.0325 7.67267 10.0952L5.75733 10.6552C5.69997 10.6719 5.63916 10.6729 5.58127 10.6581C5.52339 10.6432 5.47055 10.6131 5.4283 10.5709C5.38604 10.5286 5.35592 10.4758 5.34109 10.4179C5.32626 10.36 5.32727 10.2992 5.344 10.2418L5.904 8.32651C5.96702 8.11187 6.08302 7.91655 6.24133 7.75851L12.25 1.74917Z" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     </svg>
//                                                     {/* Delete icon */}
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
//                                                         style={{ cursor: 'pointer' }}
//                                                         onClick={() => setImprovements(prev => prev.filter(i => i.id !== item.id))}
//                                                     >
//                                                         <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                         <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     </svg>
//                                                 </div>
//                                             </>
//                                         )}
//                                     </div>
//                                 ))}
//                                 {showImprovementInput && (
//                                     <div
//                                         className="release-input-row"
//                                         ref={improvementInputRef}
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter' && newImprovementText.trim()) {
//                                                 setImprovements(prev => [
//                                                     ...prev,
//                                                     { id: Date.now(), text: newImprovementText.trim() }
//                                                 ]);
//                                                 setNewImprovementText('');
//                                                 setShowImprovementInput(false);
//                                             }
//                                             if (e.key === 'Escape') {
//                                                 setNewImprovementText('');
//                                                 setShowImprovementInput(false);
//                                             }
//                                         }}
//                                     >
//                                         <InputBoxSmall
//                                             label="New Improvement"
//                                             defaultValue={newImprovementText} 
//                                             onChange={(e) => setNewImprovementText(e.target.value)}
//                                         />

//                                         {/* ❌ CLOSE BUTTON */}
//                                         <div
//                                             className="release-close-icon"
//                                             onClick={() => {
//                                                 setNewImprovementText('');
//                                                 setShowImprovementInput(false);
//                                             }}
//                                         >
//                                             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                                 <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                 <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                             </svg>
//                                         </div>
//                                     </div>
//                                 )}

//                                 <div className='release-feature-add'>
//                                     <AddButtonWithPlus onClick={() => setShowImprovementInput(true)} />
//                                 </div>

//                             </div>
//                         </div>
//                         <div className='release-btm-right'>
//                             <div className='release-btm-right-title'>
//                                 <span>Bug fixes</span>
//                             </div>
//                             <div className='release-btm-right-content'>
//                                 {bugs.map((item) => (
//                                     <div className='release-btm-right-content-row' key={item.id}>
//                                         {editBugId === item.id ? (
//                                             // ── EDIT MODE ──
//                                             <div
//                                                 className='release-input-row'
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === 'Enter' && editBugText.trim()) {
//                                                         setBugs(prev =>
//                                                             prev.map(b => b.id === item.id
//                                                                 ? { ...b, text: editBugText.trim() }
//                                                                 : b
//                                                             )
//                                                         );
//                                                         setEditBugId(null);
//                                                     }
//                                                     if (e.key === 'Escape') setEditBugId(null);
//                                                 }}
//                                             >
//                                                 <InputBoxSmall
//                                                     label="Bug Fix"
//                                                     defaultValue={editBugText}
//                                                     onChange={(e) => setEditBugText(e.target.value)}
//                                                 />
//                                                 <div
//                                                     className="release-close-icon"
//                                                     onClick={() => setEditBugId(null)}
//                                                 >
//                                                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                                         <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                         <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     </svg>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             // ── VIEW MODE ──
//                                             <>
//                                                 <span className='bug-icon-left'></span>
//                                                 <span className='release-btm-text-left'>{item.text}</span>
//                                                 <div className='release-btm-text-right'>
//                                                     {/* Edit icon */}
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
//                                                         style={{ cursor: 'pointer' }}
//                                                         onClick={() => {
//                                                             setEditBugId(item.id);
//                                                             setEditBugText(item.text);
//                                                         }}
//                                                     >
//                                                         <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
//                                                         <path d="M12.25 1.74917C12.5152 1.48396 12.8749 1.33496 13.25 1.33496C13.6251 1.33496 13.9848 1.48396 14.25 1.74917C14.5152 2.01439 14.6642 2.3741 14.6642 2.74917C14.6642 3.12425 14.5152 3.48396 14.25 3.74917L8.24133 9.75851C8.08303 9.91667 7.88747 10.0325 7.67267 10.0952L5.75733 10.6552C5.69997 10.6719 5.63916 10.6729 5.58127 10.6581C5.52339 10.6432 5.47055 10.6131 5.4283 10.5709C5.38604 10.5286 5.35592 10.4758 5.34109 10.4179C5.32626 10.36 5.32727 10.2992 5.344 10.2418L5.904 8.32651C5.96702 8.11187 6.08302 7.91655 6.24133 7.75851L12.25 1.74917Z" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     </svg>
//                                                     {/* Delete icon */}
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
//                                                         style={{ cursor: 'pointer' }}
//                                                         onClick={() => setBugs(prev => prev.filter(b => b.id !== item.id))}
//                                                     >
//                                                         <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                         <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                     </svg>
//                                                 </div>
//                                             </>
//                                         )}
//                                     </div>
//                                 ))}
//                                 {showBugInput && (
//                                     <div 
//                                     className="release-input-row"
//                                         onKeyDown={(e) => {
//                                             if (e.key === 'Enter' && newBugText.trim()) {
//                                                 setBugs(prev => [
//                                                     ...prev,
//                                                     { id: Date.now(), text: newBugText.trim() }
//                                                 ]);
//                                                 setNewBugText('');
//                                                 setShowBugInput(false);
//                                             }
//                                             if (e.key === 'Escape') {
//                                                 setNewBugText('');
//                                                 setShowBugInput(false);
//                                             }
//                                         }}
//                                     >
//                                         <InputBoxSmall
//                                             label="New Bug Fix"
//                                             defaultValue={newBugText}
//                                             onChange={(e) => setNewBugText(e.target.value)}
//                                         />
//                                         {/* ❌ CLOSE BUTTON */}
//                                         <div
//                                         className="release-close-icon"
//                                             onClick={() => {
//                                                 setNewBugText('');
//                                                 setShowBugInput(false);
//                                             }}
//                                         >
//                                             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//                                                 <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                                 <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
//                                             </svg>
//                                         </div>
//                                     </div>
//                                 )}

//                                 <div className='release-feature-add'>
//                                     <AddButtonWithPlus onClick={() => setShowBugInput(true)} />
//                                 </div> 
//                             </div>
                            
//                         </div>
//                     </div>
//                     <div className='release-final-btn-container'>
//                         <button 
//                             className='cancel-btn-rn bg-white'
//                         >
//                             Back
//                         </button>
//                         <button 
//                             className='save-draft-btn-rn'
//                         >
//                             Edit
//                         </button>
//                         <button className='release-final-btn'>Publish Release Note</button>
//                     </div>
//                 </div>
//             </div>
//           </div>
//         </div>
//     )
// }

// export default EditReleaseNotes;


import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ExportLabel from '../../../components/common/ExportLabel/Export';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import './ReleaseNotes.css';
import AddButtonWithPlus from '../../../components/common/AddButton/AddButton';
import InputBoxSmall from '../../../components/common/InputBox/InputBoxSmall';
import IconUploadButton from '../../../components/common/InputBox/UploadIconBox';
import { updateReleaseNote } from '../../../services/ReleaseNotes/Releasenotesapi';
// import { SuccessAlert } from '../../../components/common/ErrorAlert/SuccessAlert';
import ErrorNotification from '../../../components/common/AlertBox/ErrorNotification';

const EditReleaseNotes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const note = location.state?.note;

    const [selectedItems, setSelectedItems] = useState([]);

    // ── Basic fields — pre-populated from note ────────────────────
    const [version, setVersion] = useState(note?.version ?? '');
    const [releaseTitle, setReleaseTitle] = useState(note?.title ?? '');
    const [releaseDate, setReleaseDate] = useState(note?.release_date ?? '');
    const [releaseStatus, setReleaseStatus] = useState(note?.status ?? 'draft');

    // ── Submission state ──────────────────────────────────────────
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    // ── Features — pre-populated from note ───────────────────────
    const [features, setFeatures] = useState(
        (note?.features ?? []).map(f => ({ ...f, icon: f.image ?? null }))
    );
    const [showFeatureInput, setShowFeatureInput] = useState(false);
    const [newFeatureName, setNewFeatureName] = useState('');
    const [newFeatureDescription, setNewFeatureDescription] = useState('');
    const [newFeatureIcon, setNewFeatureIcon] = useState(null);
    const [editFeatureId, setEditFeatureId] = useState(null);
    const [editFeatureName, setEditFeatureName] = useState('');
    const [editFeatureDescription, setEditFeatureDescription] = useState('');
    const [editFeatureIcon, setEditFeatureIcon] = useState(null);

    // ── Improvements — pre-populated from note ────────────────────
    const [improvements, setImprovements] = useState(note?.improvements ?? []);
    const [showImprovementInput, setShowImprovementInput] = useState(false);
    const [newImprovementText, setNewImprovementText] = useState('');
    const improvementInputRef = useRef(null);
    const [editImprovementId, setEditImprovementId] = useState(null);
    const [editImprovementText, setEditImprovementText] = useState('');

    // ── Bugs — pre-populated from note ───────────────────────────
    const [bugs, setBugs] = useState(note?.bug_fixes ?? []);
    const [showBugInput, setShowBugInput] = useState(false);
    const [newBugText, setNewBugText] = useState('');
    const [editBugId, setEditBugId] = useState(null);
    const [editBugText, setEditBugText] = useState('');

    // ── Guard ─────────────────────────────────────────────────────
    if (!note) {
        return (
            <div className='whole-container'>
                <div className='pagename-container'>
                    <span className='common-text fts-16'>No release note data found.</span>
                    <button className='cancel-btn-rn bg-white' onClick={() => navigate('/release-notes')}>
                        Back
                    </button>
                </div>
            </div>
        );
    }

    // ── Validation ────────────────────────────────────────────────
    const validateData = () => {
        const errors = {};
        if (!version.trim()) errors.version = 'Version is required';
        if (!releaseTitle.trim()) errors.title = 'Release title is required';
        return { isValid: Object.keys(errors).length === 0, errors };
    };

    // ── Payload builders ──────────────────────────────────────────
    const hasFileIcons = features.some(f => f.icon instanceof File);

    const buildFormData = (status) => {
        const formData = new FormData();
        formData.append('version', version);
        formData.append('title', releaseTitle);
        if (releaseDate) formData.append('release_date', releaseDate);
        formData.append('status', status);
        formData.append('features', JSON.stringify(features.map(f => ({ name: f.name, description: f.description }))));
        features.forEach((f, index) => {
            if (f.icon instanceof File) formData.append(`feature_image_${index}`, f.icon);
        });
        formData.append('improvements', JSON.stringify(improvements.map(i => ({ text: i.text }))));
        formData.append('bug_fixes', JSON.stringify(bugs.map(b => ({ text: b.text }))));
        return formData;
    };

    const buildJsonPayload = (status) => ({
        version,
        title: releaseTitle,
        release_date: releaseDate || null,
        status,
        features: features.map(f => ({ name: f.name, description: f.description })),
        improvements: improvements.map(i => ({ text: i.text })),
        bug_fixes: bugs.map(b => ({ text: b.text })),
    });

    // ── Save Draft ────────────────────────────────────────────────
    const handleSaveDraft = async () => {
        const { isValid, errors } = validateData();
        if (!isValid) { setFormErrors(errors); return; }
        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            const payload = hasFileIcons
                ? buildFormData('draft')
                : buildJsonPayload('draft');

            const result = await updateReleaseNote(note.id, payload);

            if (result) {
                alert('Draft saved successfully.');

                navigate(`/release-notes/detail/${note.id}`, {
                    state: {
                        note: {
                            ...note,
                            version,
                            title: releaseTitle,
                            release_date: releaseDate,
                            status: 'draft',
                            features,
                            improvements,
                            bug_fixes: bugs,
                        }
                    }
                });
            }

        } finally {
            setIsSubmitting(false);
        }
    };

    // ── Publish ───────────────────────────────────────────────────
    const handlePublish = async () => {
        const { isValid, errors } = validateData();
        if (!isValid) { setFormErrors(errors); return; }
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const payload = hasFileIcons ? buildFormData('published') : buildJsonPayload('published');
            const result = await updateReleaseNote(note.id, payload);
            if (result) {
                alert('Release note published successfully!');

                navigate(`/release-notes/detail/${note.id}`, {
                    state: {
                        note: {
                            ...note,
                            version,
                            title: releaseTitle,
                            release_date: releaseDate,
                            status: 'published',
                            features,
                            improvements,
                            bug_fixes: bugs,
                        }
                    }
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='whole-container'>
            <div className='top-heading'>
                <PageHeader pageName=" Engagement / Release Notes /" nestedpageName="Edit" linkTo="/release-notes" />
                {/* <div className='export-container'>
                    <ArchiveSelectedItem selectedItems={selectedItems} />
                    <ExportLabel />
                </div> */}
            </div>
            <div className='pagename-container'>
                <div className='page-name'>
                    <h1 className='common-text fts-22 ftw-6 blue'>Edit Release Note</h1>
                </div>
            </div>
            <div className='table-container'>
                <div className='add-release-note-container'>

                    {/* ── ERROR BANNER ── */}
                    <div>
                        <ErrorNotification
                            errors={formErrors}
                            width="100%"
                            marginBottom="1rem"
                        />
                    </div>

                    {/* ── BASIC INFO ── */}
                    <div className='release-basic-container'>
                        <div className='release-basic-header'>
                            <span className='release-header-title'>Basic Information</span>
                        </div>
                        <div className='release-basic-content'>
                            <div className='release-version-container'>
                                <InputBoxSmall
                                    label="Version"
                                    defaultValue={version}
                                    onChange={(e) => {
                                        setVersion(e.target.value);
                                        if (formErrors.version) setFormErrors(prev => { const { version: _, ...rest } = prev; return rest; });
                                    }}
                                    // error={formErrors.version}
                                />
                            </div>
                            <div className='release-basic-description-container'>
                                <InputBoxSmall
                                    label="Release title"
                                    defaultValue={releaseTitle}
                                    onChange={(e) => {
                                        setReleaseTitle(e.target.value);
                                        if (formErrors.title) setFormErrors(prev => { const { title: _, ...rest } = prev; return rest; });
                                    }}
                                    // error={formErrors.title}
                                />
                                <InputBoxSmall
                                    label="Release date"
                                    type='small-date'
                                    defaultValue={releaseDate}
                                    onChange={(e) => setReleaseDate(e.target.value)}
                                />
                                <InputBoxSmall
                                    label="Status"
                                    defaultValue={releaseStatus}
                                    readOnly
                                />
                            </div>
                            <div className='release-basic-bt-text'>
                                <span>This title is for internal use only and will not be shown to users.</span>
                            </div>
                        </div>
                    </div>

                    {/* ── FEATURE INFO ───────────────────────────────────────── */}
                    <div className='release-feature-container'>
                        <div className='release-feature-header'>
                            <span className='release-header-title'>Feature Information</span>
                        </div>
                        <div className='release-feature-content-container'>
                            <div className='release-feature-titles'>
                                <span>Icon</span>
                                <span>Feature Name</span>
                                <span>Description (40–50 characters)</span>
                            </div>
                            <div className='release-feature-content'>
                                {features.map((item) => (
                                    <div className='release-feature-row' key={item.id}>
                                        {editFeatureId === item.id ? (
                                            <div className='release-input-row'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && editFeatureName.trim()) {
                                                        setFeatures(prev => prev.map(f => f.id === item.id
                                                            ? { ...f, name: editFeatureName.trim(), description: editFeatureDescription.trim(), icon: editFeatureIcon }
                                                            : f
                                                        ));
                                                        setEditFeatureId(null);
                                                    }
                                                    if (e.key === 'Escape') setEditFeatureId(null);
                                                }}
                                            >
                                                <IconUploadButton icon={editFeatureIcon} onIconChange={(icon) => setEditFeatureIcon(icon)} />
                                                <InputBoxSmall label="Feature Name" defaultValue={editFeatureName} onChange={(e) => setEditFeatureName(e.target.value)} maxLength={30} />
                                                <InputBoxSmall label="Description (40–50 characters)" defaultValue={editFeatureDescription} onChange={(e) => setEditFeatureDescription(e.target.value)} maxLength={50} />
                                                <div className="release-close-icon" onClick={() => setEditFeatureId(null)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div className='release-feature-content-left-row'>
                                                    <IconUploadButton
                                                        icon={item.icon}
                                                        onIconChange={(newIcon) => setFeatures(prev => prev.map(f => f.id === item.id ? { ...f, icon: newIcon } : f))}
                                                    />
                                                    <span>{item.name}</span>
                                                    <span>{item.description}</span>
                                                </div>
                                                <div className='release-feature-content-right-row'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }}
                                                        onClick={() => { setEditFeatureId(item.id); setEditFeatureName(item.name); setEditFeatureDescription(item.description); setEditFeatureIcon(item.icon ?? null); }}
                                                    >
                                                        <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M12.25 1.74917C12.5152 1.48396 12.8749 1.33496 13.25 1.33496C13.6251 1.33496 13.9848 1.48396 14.25 1.74917C14.5152 2.01439 14.6642 2.3741 14.6642 2.74917C14.6642 3.12425 14.5152 3.48396 14.25 3.74917L8.24133 9.75851C8.08303 9.91667 7.88747 10.0325 7.67267 10.0952L5.75733 10.6552C5.69997 10.6719 5.63916 10.6729 5.58127 10.6581C5.52339 10.6432 5.47055 10.6131 5.4283 10.5709C5.38604 10.5286 5.35592 10.4758 5.34109 10.4179C5.32626 10.36 5.32727 10.2992 5.344 10.2418L5.904 8.32651C5.96702 8.11187 6.08302 7.91655 6.24133 7.75851L12.25 1.74917Z" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }}
                                                        onClick={() => setFeatures(prev => prev.filter(f => f.id !== item.id))}
                                                    >
                                                        <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ))}
                                {showFeatureInput && (
                                    <div className='release-input-row'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && newFeatureName.trim()) {
                                                if (features.length >= 4) return;
                                                setFeatures(prev => [...prev, { id: Date.now(), name: newFeatureName.trim(), description: newFeatureDescription.trim(), icon: newFeatureIcon }]);
                                                setNewFeatureName(''); setNewFeatureDescription(''); setNewFeatureIcon(null); setShowFeatureInput(false);
                                            }
                                            if (e.key === 'Escape') { setNewFeatureName(''); setNewFeatureDescription(''); setNewFeatureIcon(null); setShowFeatureInput(false); }
                                        }}
                                    >
                                        <IconUploadButton icon={newFeatureIcon} onIconChange={(icon) => setNewFeatureIcon(icon)} />
                                        <InputBoxSmall label="Feature Name" value={newFeatureName} onChange={(e) => setNewFeatureName(e.target.value)} maxLength={30} />
                                        <InputBoxSmall label="Description (40–50 characters)" value={newFeatureDescription} onChange={(e) => setNewFeatureDescription(e.target.value)} maxLength={50} />
                                        <div className="release-close-icon" onClick={() => { setNewFeatureName(''); setNewFeatureDescription(''); setNewFeatureIcon(null); setShowFeatureInput(false); }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                )}
                                <div className='release-feature-add'>
                                    <AddButtonWithPlus onClick={() => setShowFeatureInput(true)} disabled={features.length >= 4} />
                                </div>
                            </div>
                        </div>

                        <hr />

                        {/* ── IMPROVEMENTS + BUGS ────────────────────────────── */}
                        <div className='release-btm-container'>

                            {/* Improvements */}
                            <div className='release-btm-left'>
                                <div className='release-btm-left-title'><span>Improvements</span></div>
                                <div className='release-btm-left-content'>
                                    {improvements.map((item) => (
                                        <div className='release-btm-left-content-row' key={item.id}>
                                            {editImprovementId === item.id ? (
                                                <div className='release-input-row'
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' && editImprovementText.trim()) {
                                                            if (improvements.length >= 6) return;
                                                            setImprovements(prev => prev.map(i => i.id === item.id ? { ...i, text: editImprovementText.trim() } : i));
                                                            setEditImprovementId(null);
                                                        }
                                                        if (e.key === 'Escape') setEditImprovementId(null);
                                                    }}
                                                >
                                                    <InputBoxSmall label="Improvement" defaultValue={editImprovementText} onChange={(e) => setEditImprovementText(e.target.value)} maxLength={60} />
                                                    <div className="release-close-icon" onClick={() => setEditImprovementId(null)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span className='imp-icon-left'></span>
                                                    <span className='release-btm-text-left'>{item.text}</span>
                                                    <div className='release-btm-text-right'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }}
                                                            onClick={() => { setEditImprovementId(item.id); setEditImprovementText(item.text); }}
                                                        >
                                                            <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path d="M12.25 1.74917C12.5152 1.48396 12.8749 1.33496 13.25 1.33496C13.6251 1.33496 13.9848 1.48396 14.25 1.74917C14.5152 2.01439 14.6642 2.3741 14.6642 2.74917C14.6642 3.12425 14.5152 3.48396 14.25 3.74917L8.24133 9.75851C8.08303 9.91667 7.88747 10.0325 7.67267 10.0952L5.75733 10.6552C5.69997 10.6719 5.63916 10.6729 5.58127 10.6581C5.52339 10.6432 5.47055 10.6131 5.4283 10.5709C5.38604 10.5286 5.35592 10.4758 5.34109 10.4179C5.32626 10.36 5.32727 10.2992 5.344 10.2418L5.904 8.32651C5.96702 8.11187 6.08302 7.91655 6.24133 7.75851L12.25 1.74917Z" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }}
                                                            onClick={() => setImprovements(prev => prev.filter(i => i.id !== item.id))}
                                                        >
                                                            <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                    {showImprovementInput && (
                                        <div className="release-input-row" ref={improvementInputRef}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && newImprovementText.trim()) {
                                                    if (improvements.length >= 6) return;
                                                    setImprovements(prev => [...prev, { id: Date.now(), text: newImprovementText.trim() }]);
                                                    setNewImprovementText(''); setShowImprovementInput(false);
                                                }
                                                if (e.key === 'Escape') { setNewImprovementText(''); setShowImprovementInput(false); }
                                            }}
                                        >
                                            <InputBoxSmall label="New Improvement" defaultValue={newImprovementText} onChange={(e) => setNewImprovementText(e.target.value)} maxLength={60} />
                                            <div className="release-close-icon" onClick={() => { setNewImprovementText(''); setShowImprovementInput(false); }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                    <div className='release-feature-add'>
                                        <AddButtonWithPlus onClick={() => setShowImprovementInput(true)} disabled={improvements.length >= 6} />
                                    </div>
                                </div>
                            </div>

                            {/* Bug Fixes */}
                            <div className='release-btm-right'>
                                <div className='release-btm-right-title'><span>Bug Fixes</span></div>
                                <div className='release-btm-right-content'>
                                    {bugs.map((item) => (
                                        <div className='release-btm-right-content-row' key={item.id}>
                                            {editBugId === item.id ? (
                                                <div className='release-input-row'
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' && editBugText.trim()) {
                                                            if (bugs.length >= 6) return;
                                                            setBugs(prev => prev.map(b => b.id === item.id ? { ...b, text: editBugText.trim() } : b));
                                                            setEditBugId(null);
                                                        }
                                                        if (e.key === 'Escape') setEditBugId(null);
                                                    }}
                                                >
                                                    <InputBoxSmall label="Bug Fix" defaultValue={editBugText} onChange={(e) => setEditBugText(e.target.value)} maxLength={60} />
                                                    <div className="release-close-icon" onClick={() => setEditBugId(null)}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span className='bug-icon-left'></span>
                                                    <span className='release-btm-text-left'>{item.text}</span>
                                                    <div className='release-btm-text-right'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }}
                                                            onClick={() => { setEditBugId(item.id); setEditBugText(item.text); }}
                                                        >
                                                            <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path d="M12.25 1.74917C12.5152 1.48396 12.8749 1.33496 13.25 1.33496C13.6251 1.33496 13.9848 1.48396 14.25 1.74917C14.5152 2.01439 14.6642 2.3741 14.6642 2.74917C14.6642 3.12425 14.5152 3.48396 14.25 3.74917L8.24133 9.75851C8.08303 9.91667 7.88747 10.0325 7.67267 10.0952L5.75733 10.6552C5.69997 10.6719 5.63916 10.6729 5.58127 10.6581C5.52339 10.6432 5.47055 10.6131 5.4283 10.5709C5.38604 10.5286 5.35592 10.4758 5.34109 10.4179C5.32626 10.36 5.32727 10.2992 5.344 10.2418L5.904 8.32651C5.96702 8.11187 6.08302 7.91655 6.24133 7.75851L12.25 1.74917Z" stroke="#094C80" strokeWidth="1.06667" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }}
                                                            onClick={() => setBugs(prev => prev.filter(b => b.id !== item.id))}
                                                        >
                                                            <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                        </svg>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                    {showBugInput && (
                                        <div className="release-input-row"
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && newBugText.trim()) {
                                                    if (bugs.length >= 6) return;
                                                    setBugs(prev => [...prev, { id: Date.now(), text: newBugText.trim() }]);
                                                    setNewBugText(''); setShowBugInput(false);
                                                }
                                                if (e.key === 'Escape') { setNewBugText(''); setShowBugInput(false); }
                                            }}
                                        >
                                            <InputBoxSmall label="New Bug Fix" defaultValue={newBugText} onChange={(e) => setNewBugText(e.target.value)} maxLength={60} />
                                            <div className="release-close-icon" onClick={() => { setNewBugText(''); setShowBugInput(false); }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M13.8 3L2.79999 14" stroke="#FA0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M2.79999 3L13.8 14" stroke="#FF0000" strokeWidth="1.07" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                    <div className='release-feature-add'>
                                        <AddButtonWithPlus onClick={() => setShowBugInput(true)} disabled={bugs.length >= 6} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ── ACTION BUTTONS ─────────────────────────────────── */}
                        <div className='release-final-btn-container'>
                            <button
                                className='cancel-btn-rn bg-white'
                                onClick={() => navigate(-1)}
                            >
                                Back
                            </button>
                            <button
                                className='save-draft-btn-rn'
                                onClick={handleSaveDraft}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Saving...' : 'Save Draft'}
                            </button>
                            <button
                                className='release-final-btn'
                                onClick={handlePublish}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Publishing...' : 'Publish Release Note'}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default EditReleaseNotes;